<template>
  <v-row id="catalogMainPage" class="mt-8 overview-container py-0" no-gutters>
    <!-- Category menu -->
    <v-col cols="12" :md="isMobile ? 0 : 2">
      <CategoryMenu :categories="categories" />
    </v-col>
    <v-col cols="12" :md="isMobile ? 12 : 10">
      <!-- Product search bar -->
      <v-row no-gutters class="mt-3 mb-6">
        <v-col cols="12" md="8" class="pl-md-6">
          <ProductSearchBar v-if="products.length > 0" :items="products" />
        </v-col>
        <v-col cols="12" md="auto" class="d-flex align-center justify-center justify-md-start">
          <v-btn v-if="isKid" text link :to="{ name: 'CartOverview' }" class="body-text-medium">
            <v-icon left size="17">fas fa-shopping-cart</v-icon>
            Cart
          </v-btn>
        </v-col>
      </v-row>
      <!-- Product list -->
      <v-row no-gutters>
        <v-row justify="center" align="center" class="mb-10">
          <div class="heading-h3">Feature Products</div>
        </v-row>
        <ProductList :products="products" />
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import ProductList from "@/components/Products/ProductList";
  import CategoryMenu from "@/components/Catalog/CategoryMenu";
  import ProductSearchBar from "@/components/Catalog/ProductSearchBar";

  export default {
    name: "Catalog",

    data() {
      return {};
    },

    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.mobile;
      },

      isKid() {
        return this.$store.getters.userInfo.role === "child";
      },

      products() {
        return this.$store.getters.getProducts();
      },

      categories() {
        return this.$store.state.products.categories;
      },
    },

    components: {
      ProductList,
      CategoryMenu,
      ProductSearchBar,
    },

    methods: {
      fetchProducts() {
        this.$http
          .get("/products")
          .then((response) => {
            this.$store.commit("addProducts", response.data.products);
          })
          .catch((error) => {
            console.error(error);
            this.$store.commit("setError", {
              message: "Failed to retrieve products information",
              type: "error",
            });
          });
      },

      fetchCategories() {
        this.$http
          .get("/categories")
          .then((response) => {
            this.$store.commit("addCategories", response.data.categories);
          })
          .catch((error) => {
            console.error(error);
            this.$store.commit("setError", {
              message: "Failed to retrieve categories information",
              type: "error",
            });
          });
      },
    },

    created() {
      this.$store.commit("clearCategoryFilters");
      this.fetchProducts();
      this.fetchCategories();
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Catalog/Catalog.vue